class LocalStorage {
  set (key, value) {
    window.localStorage.setItem(key, value)
  }

  get (key) {
    return window.localStorage.getItem(key)
  }

  remove (key) {
    window.localStorage.removeItem(key)
  }

  setSessionToken (token) {
    this.set('ADMIN.SESSION_TOKEN', token)
  }

  getSessionToken () {
    return this.get('ADMIN.SESSION_TOKEN')
  }

  removeSessionToken () {
    this.remove('ADMIN.SESSION_TOKEN')
  }

  // Geofences

  setGeofenceByType (value) {
    this.set('geofenceType', value)
  }

  getGeofenceByType () {
    return this.get('geofenceType')
  }

  setGeofenceByStatus (value) {
    this.set('geofenceStatus', value)
  }

  getGeofenceByStatus () {
    return this.get('geofenceStatus')
  }

  setGeofenceByBrand (value) {
    this.set('geofenceBrand', value)
  }

  getGeofenceByBrand () {
    return this.get('geofenceBrand')
  }

  // Pricing

  setBrandInPricing (value) {
    this.set('pricingBrand', value)
  }

  getBrandInPricing () {
    return this.get('pricingBrand')
  }

  // Service Management

  setServiceBrand (value) {
    this.set('serviceBrand', value)
  }

  getServiceBrand (value) {
    return this.get('serviceBrand')
  }
}

export default LocalStorage



// WEBPACK FOOTER //
// ./src/modules/plugins/local-storage.js